import {
  type ComponentProps,
  type ComponentType,
  CSSProperties,
  forwardRef,
} from 'react';
import cl from 'clsx';

import classes from './IconButton.module.scss';

/*
- clickable icon
- customisable - class, style
*/
export type IconButtonProps = Omit<ComponentProps<'button'>, 'children'> & {
  Icon: ComponentType<ComponentProps<'svg'>>;
  iconClassName?: string;
  iconStyle?: CSSProperties;
};

export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  function IconButton(
    {
      type = 'button',

      Icon,
      iconClassName = classes.icon,
      iconStyle,

      className,

      disabled: disabledProp,

      ...rest
    },
    ref,
  ) {
    const disabled = disabledProp;
    return (
      <button
        type={type}
        ref={ref}
        disabled={disabled}
        className={cl(classes.root, className)}
        {...rest}
      >
        <Icon className={iconClassName} style={iconStyle} />
      </button>
    );
  },
);
